export class UpdateContractProcedure {
  static readonly type = '[Contract.Procedure] Update';
  constructor(public procedure: any) {}
}
